import { i18next } from '@frontend/i18n';
import { dropdownField, switchField, textareaField, textField } from '../../../utils/field-config-helpers';

export const hiddenFieldsConfig = {
  rescheduleApptWithinDuration: switchField(),
  rescheduleDuration: dropdownField(),
  rescheduleCharges: textField(),
  cancellationCharges: textField(),
  wifiAvailability: switchField(),
  refreshmentAvailability: switchField(),
  anxiousPatient: textareaField(),
  salesPitchNewPatient: textareaField(),
  customPostBookingInstructions: textareaField({
    validator: (props) => {
      const val = props.value?.trim();
      try {
        const parsed = JSON.parse(val);
        if (typeof parsed !== 'object' || Array.isArray(parsed)) {
          return i18next.t('Must be a valid JSON object', { ns: 'ai-receptionist-settings' });
        }
        return '';
      } catch {
        return i18next.t('Must be a valid JSON object', { ns: 'ai-receptionist-settings' });
      }
    },
  }),
  sendStaffInfo: switchField(),
};

export type HiddenFieldsConfigTypes = typeof hiddenFieldsConfig;
